import { render, staticRenderFns } from "./DistributorParents.vue?vue&type=template&id=ca02fb42&"
import script from "./DistributorParents.vue?vue&type=script&lang=js&"
export * from "./DistributorParents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports